// Set webpack asset host at runtime. Must be imported at top of entrypoints.
import '../helpers/asset_host';
import ReactComponentRegistry from 'react_component_registry';
import AppDirectoryWrapper from '../components/pie/app_directory_wrapper';
import AppListingWrapper from '../components/pie/app_listing_wrapper';

ReactComponentRegistry.register({ AppDirectoryWrapper, AppListingWrapper });
